import { ConfirmModalVariant } from '../ConfirmModal';

export function confirmModalContent(variant: ConfirmModalVariant) {
  if (variant === ConfirmModalVariant.QUOTES) {
    return 'Confirming will allow us to give quotes for your new address and end your current contract on your moving day.';
  }

  if (variant === ConfirmModalVariant.END_CONTRACT) {
    return "Before you continue, check if you've given us the right address. If you need to update it later, you'll need to call us.";
  }

  if (variant === ConfirmModalVariant.NO_UK_ADDRESS) {
    return "Before you continue, make sure the moving day you've given us is correct. You can update this later if things change.";
  }
}
